import React from 'react';

import { Loader } from '../Loader';

const Loading = ({ className: classNameProp = '', isLoading, children, size = 60 }) => {
  if (isLoading) {
    return <Loader size={size} className={classNameProp} />;
  }
  return children;
};

export default Loading;
